export default __webpack_public_path__ + "static/media/data-driven-maintenance.b9cc7707.svg";